import React, { useState } from 'react';
import Card from 'components/Layout/Card';
import EmailTemplateSideBar from './EmailTemplateSideBar';
import EmailPreview from './EmailPreview';
import EmailTemplateForm from './EmailTemplateForm';
import EmailTemplateHistory from './EmailTemplateHistory';

const EmailTemplates = () => {
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [view, setView] = useState('preview'); // preview | form | history
  return (
    <div className="row ">
      {/* Sidebar */}
      <div className="col-lg-5 col-md-12 col-12 mb-3 mb-lg-0">
        <EmailTemplateSideBar
          onSelectTemplate={(template) => {
            setSelectedTemplate(template);
            setView('preview');
          }}
        />
      </div>

      {/* Main content */}
      <div className="col-lg-7 col-md-12 col-12">
        {view === 'preview' && selectedTemplate && (
          <EmailPreview
            template={selectedTemplate}
            onEdit={() => setView('form')}
            onHistory={() => setView('history')}
          />
        )}

        {view === 'form' && selectedTemplate && (
          <EmailTemplateForm
            template={selectedTemplate}
            setSelectedTemplate={setSelectedTemplate}
            onClose={() => setView('preview')}
            onHistory={() => setView('history')}
          />
        )}

        {view === 'history' && selectedTemplate && (
          <EmailTemplateHistory
            template={selectedTemplate}
            onClose={() => setView('preview')}
          />
        )}
        {selectedTemplate === null && (
          <Card className="d-flex justify-content-center align-items-center h-100">
            No Selected Email Template
          </Card>
        )}
      </div>
    </div>
  );
};

export default EmailTemplates;
